import React from 'react';

export default function DeployedRowStatusBadge({ responseCount = 0, sentCount = 0, lastActivityAt }) {
    const isActive = lastActivityAt && (Date.now() - new Date(lastActivityAt).getTime()) < 3600000;

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11 }}>
            <span style={{
                padding: '1px 6px', borderRadius: 8, fontSize: 10,
                background: '#F1F3F4', color: '#5F6368',
            }}>
                {responseCount} / {sentCount}
            </span>
            {isActive && (
                <span style={{
                    width: 6, height: 6, borderRadius: '50%',
                    background: '#34A853', display: 'inline-block',
                }} title="Active in the last hour" />
            )}
        </span>
    );
}
